import React, { Fragment, useEffect, useRef, useState } from "react";
import Breadcrumb from "../../../../layout/breadcrumb";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import salesOrderReducer from "./../../store";
import withReducer from "../../../../store/withReducer";
import PreLoader from "../../../../share-components/ui/preLoader";
import AsyncSelect from "react-select/async";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  mapSearchCustomerAutoSuggestion,
  mapSearchPaymentMethodAutoSuggestion,
  mapSearchCurrencyAutoSuggestion,
} from "../../../../utils/mapper";
import { customerAutoSuggestionApi } from "../../../../services/order";
import OrderCustomerAddress from "./content/orderCustomerAddress";
import {
  getCountryList,
  getCountryListData,
  setSearchProductDialog,
} from "../../store/draftOrderSlice";
import SearchProductModal from "../../draft-order/form/content/searchProductModal";
import SaleOrderProductJqx from "./content/saleOrderProductJqx";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";
import OrderDiscount from "../../draft-order/form/content/orderDiscount";
import OrderShipment from "../../draft-order/form/content/orderShipment";
import OrderTax from "../../draft-order/form/content/orderTax";
import SaleOrderPayment from "./content/saleOrderPayment";
import SalesOrderDuty from "./content/salesOrderDuty";
import {
  orderCommodities,
  productTaxAmount,
  shippingTaxAmount,
} from "../setting/calculation";
import {
  addSalesOrders,
  editSaleOrder,
  getExchangeRate,
  getSalesOrderDefaultShipping,
  updateSalesOrder,
} from "../../store/salesOrderSlice";
import { useHistory, useParams } from "react-router-dom";
import { getCurrencyAutoSuggestionApi } from "../../../../services/manage-order/saleOrderService";
import LogActivity from "../../../log";
import { getPaymentAutoSuggestionApi } from "../../../../services/manage-order/setting/paymentMethodService";
import { toast } from "react-toastify";

const defaultValues = {
  id: "",
  ordered_products: [],
  currency: { value: 50, label: "GBP", symbol: "£" },
  customer_po_no: "",
  memo: "",
  discount: "",
  shipping: "",
  currency_rate: 1,
  duty: "",
  tax: "",
  is_tax: false,
  is_vat: false,
  customer: "",
  special_notes: "",
  shopify_draft_order_id: "",
  shippingAddress: "",
  billingAddress: "",
  total_price: 0,
  total_tax: 0,
  total_sub_total: 0,
  total_discount: 0,
  payment_method: "",
};

yup.addMethod(yup.array, "LocationRequired", function (errorMessage) {
  return this.test(`test-card-length`, errorMessage, function (value) {
    const { path, createError } = this;
    let isValid = true;
    let message = "";
    value.map((item, index) => {
      const totalQuantity = item.inventory_location.reduce(
        (sum, product) => sum + product.quantity,
        0
      );
      if (totalQuantity != item.quantity) {
        isValid = false;
        message += item.sku + ",";
      }
    });

    message = message.substring(0, message.length - 1);

    return (
      isValid || createError({ path, message: message + " " + errorMessage })
    );
  });
});

yup.addMethod(yup.mixed, "addressRequired", function (errorMessage) {
  return this.test(`test-card-length`, errorMessage, function (value) {
    const { path, createError } = this;
    let isValid = false;

    if (
      value.address1 &&
      value.city &&
      value.phone &&
      value.province &&
      value.first_name &&
      value.last_name &&
      value.city
    ) {
      isValid = true;
    }

    return isValid || createError({ path, message: errorMessage });
  });
});

const dataMenu = [
  {
    type: 1,
    text: "Sales Order",
    link: "/order/sale",
  },
  {
    type: 0,
    text: "Form",
  },
];

export const schema = yup.object().shape({
  customer: yup
    .object()
    .shape({ value: yup.string() })
    .nullable()
    .required("You must select a customer."),
  shipping: yup
    .object()
    .shape({ rate_name: yup.string().typeError("Shipment rate is required.") })
    .required("Shipment is required.")
    .typeError("Shipment is required."),
  shippingAddress: yup.object().addressRequired("You must fill all details."),
  billingAddress: yup.object().addressRequired("You must fill all details."),
  ordered_products: yup
    .array()
    .LocationRequired("Location mismatch with quantity."),
});
const SalesOrderForm = (props) => {
  const { id } = useParams();
  console.log(props);
  const dispatch = useDispatch();
  let history = useHistory();

  const [loading, isSetLoading] = useState(true);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [isProductValueChange, setIsProductValueChange] = useState(true);
  const [currencyChange, setCurrencyChange] = useState(false);
  const [isTax, setIsTax] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  const [country, setCountry] = useState("");
  const [currency, setCurrency] = useState("");
  const [subTotal, setSubTotal] = useState("");
  const [weight, setWeight] = useState("");
  const [dbShipping, setDbShipping] = useState(false);
  const [editShip, setEditShip] = useState("");
  const [isLoadingShipping, setIsLoadingShipping] = useState(false);
  const [isSufficient,setIsSufficient] = useState(history.location.state?.data);

  let searchProductRef = useRef();
  const draftOrderState = useSelector(({ order }) => order.draftOrder);
  const defaultShipping = useSelector(
    (state) => state.order.salesOrder.settings.defaultShipping
  );

  const {
    handleSubmit,
    formState,
    reset,
    control,
    register,
    setValue,
    trigger,
    getValues,
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { errors, isDirty } = formState;
  const salesOrderState = useSelector(({ order }) => order.salesOrder);

  const [isDateBlocked, setIsDateBlocked] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);

  // Track submit attempts
  const [customErrorMessage, setCustomErrorMessage] = useState([]);

  // Collect all error messages for alert display
  const getAllErrorMessages = () => {
    const messages = [];
    if (errors.customer?.message) messages.push(errors.customer.message);
    if (errors.currency?.message) messages.push(errors.currency.message);
    if (errors.payment_method?.message) messages.push(errors.payment_method.message);
    if (errors.shippingAddress?.message) messages.push(errors.shippingAddress.message);
    if (errors.billingAddress?.message) messages.push(errors.billingAddress.message);
    if (errors.ordered_products?.message) messages.push(errors.ordered_products.message);
    if (errors.shipping) {
      if (errors.shipping.message) messages.push(errors.shipping.message);
      if (errors.shipping.rate_name?.message) messages.push(errors.shipping.rate_name.message);
    }
    // Add any other error fields as needed
    return messages;
  };

  // Show toast error when form is submitted and there are errors
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      toast.error("Some fields have errors. Please review and correct them.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
      });

      setCustomErrorMessage(getAllErrorMessages());
    }
  }, [errors]);

  useEffect(
    function () {
      if (id) {
        dispatch(editSaleOrder({ id: id })).then((res) => {
          reset(res.payload);
          isSetLoading(false);
          setShowSearch(true);
          setDbShipping(res.payload.shipping == null);
          setEditShip(res.payload.shipping);
          onChangeDialog(true);
          if (res.payload.date) {
            setIsDateBlocked(res.payload.date.substring(0, 10) < '2026-03-01');
          }
          setIsReadOnly(res.payload.status_id !== 0);
        });
      } else {
        setDbShipping(true);
        isSetLoading(false);
      }
    },
    [id,isSufficient]
  );
  const typePromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(
          mapSearchCustomerAutoSuggestion(customerAutoSuggestionApi(data))
        );
      });
    });

  const currencyTypePromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(
          mapSearchCurrencyAutoSuggestion(getCurrencyAutoSuggestionApi(data))
        );
      });
    });

  const paymentTypePromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(
          mapSearchPaymentMethodAutoSuggestion(
            getPaymentAutoSuggestionApi(data)
          )
        );
      });
    });

  const openSearchProductDialog = () => {
    const obj = {
      props: { isOpen: true },
      data: { searchValue: searchProductRef.current.value },
    };
    dispatch(setSearchProductDialog(obj));
  };

  const onSubmit = (data) => {
     setButtonDisable(true);
    let line_items = [];
    data.ordered_products.map((item, index) => {
      line_items.push({
        id: item.id,
        sku: item.sku,
        variant_id: item.variant,
        quantity: item.quantity,
        back_order_quantity: item.back_order_quantity,
        price: item.price,
        product_id: item.product_id,
        sub_total_price: item.total_price,
        tax_price: item.tax_amount,
        gross_price: item.gross_amount,
        is_tax: item.is_tax,
        discount: item.discount,
        item_discount: item.item_discount,
        is_percentage: getValues("is_percentage"),
        inventory_location: item.inventory_location,
      });
    });
    data.ordered_products = line_items;
    data.customer = data.customer.value;
    data.currency = data.currency.value;
    data.payment_method_id = data.payment_method?.value;
    if (data.id) {
      dispatch(updateSalesOrder({ ...data })).then((res) => {
        if (!res.error) {
          setButtonDisable(false);
           const responseData=res.payload;
          if(responseData.insufficient_variants){
            const result = (responseData.insufficient_variants).map(item => item.sku).join(", ");
            setIsSufficient(result);

          }else {
            history.push("/order/sale");
          }
        }
      });
    } else {
      dispatch(addSalesOrders({ ...data })).then((res) => {
        if (!res.error) {
          setButtonDisable(false);
          const responseData=res.payload;
          if(responseData.insufficient_variants){
            const result = (responseData.insufficient_variants).map(item => item.sku).join(", ");
            history.push({
              pathname:  "/order/sale/"+responseData.order_data.id+"/edit",
              state: {data: result}
            })

          }else {
            history.push("/order/sale");
          }
        }
      });
    }
  };

  const handleAddProduct = (product) => {
    // setSelectedProducts([...selectedProducts, product]);
  };

  const handleCurrencyChange = (data) => {
    const paramsData = { currency: data.label };
    dispatch(getExchangeRate(paramsData)).then((res) => {
      setValue("currency_rate", res.payload);
      setCurrencyChange(res.payload);
    });
  };
  useEffect(() => {
    dispatch(getCountryList()).then((res) => {
      dispatch(getCountryListData(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    const shippingAddress = getValues("shippingAddress");
    const currency = getValues("currency");
    const orderedProducts = getValues("ordered_products");

    if (shippingAddress && shippingAddress.country) {
      setCountry(shippingAddress.country);
    }

    if (currency) {
      setCurrency(currency);
    }

    let totalSubTotal = 0;
    let totalWeight = 0;

    if (orderedProducts && orderedProducts.length > 0) {
      orderedProducts.forEach((product) => {
        totalSubTotal += product.total_price || 0;
        totalWeight += product.weight || 0;
      });
    }

    const country = shippingAddress ? shippingAddress.country : null;
    const weight = totalWeight;
    const subTotal = totalSubTotal;

    const data = { country, subTotal, currency, weight };

    if (totalSubTotal > 0 && !id) {
      getSalesOrderDefaultShippingData(data);
    } else {
      if (getValues("sub_total") !== subTotal) {
        if (subTotal > 0) {
          getSalesOrderDefaultShippingData(data);
        }
      }
    }

    setSubTotal(totalSubTotal);
    setWeight(totalWeight);
  }, [
    getValues("ordered_products"),
    getValues("shippingAddress"),
    getValues("currency"),
  ]);

  // useEffect(() => {
  //   trigger("shipping");
  //   console.log("trig 01");
  // }, [defaultShipping]);

  // useEffect(() => {
  //   const currentShippingValue = getValues("shipping")?.price;

  //   if (dbShipping && defaultShipping) {
  //     // if (defaultShipping) {
  //     if (Object.keys(defaultShipping).length !== 0) {
  //       const { name, ship_price } = defaultShipping;
  //       const price = parseFloat(ship_price) ?? 0;

  //       const shippingValue = {
  //         price: !isNaN(price) ? price : 0,
  //         rate_name: name,
  //         shipping_type: "2",
  //       };

  //       console.log("trig 02");
  //       setValue("shipping", shippingValue);
  //     } else {
  //       console.log("trig 03");
  //       setValue("shipping", "");
  //     }
  //   }

  //   const updatedShippingValue = getValues("shipping");
  // }, [defaultShipping, setValue, getValues]);

  const getSalesOrderDefaultShippingData = (data) => {
    setIsLoadingShipping(true);
    dispatch(getSalesOrderDefaultShipping(data)).then((res) => {
      if (!res.error) {
        const shippingValue = {
          price: res.payload.ship_price ? res.payload.ship_price : 0,
          rate_name: res.payload.name ? res.payload.name : "",
          shipping_type: "2",
        };
        setValue("shipping", shippingValue);

        const productTax = productTaxAmount(getValues);
        if (productTax > 0 || getValues("is_vat")) {
          const totalTax = shippingTaxAmount(getValues);
          setValue("tax", {
            is_charge: true,
            rate_name: "Vat",
            percentage: productTax + totalTax,
          });
        }
      }
      setIsLoadingShipping(false);
      trigger("shipping");
      trigger("ordered_products");
    });
  };

  const onChangeDialog = (isTrigger) => {
    trigger("ordered_products");

    if (id && !dbShipping) {
      const data = { country, subTotal, currency, weight };
      if (subTotal > 0) {
        // getSalesOrderDefaultShippingData(data);
      }
    }
    if (isTrigger) {
      setIsProductValueChange(!isProductValueChange);
    }
  };

  return (
    <Fragment>
      <Breadcrumb title="Sales Order" data={dataMenu} />
      <Container fluid={true} className="product-wrapper">
        {loading ? (
          <>
            <PreLoader></PreLoader>
          </>
        ) : (
          <>
            <Row>
              {id && (
                <div
                  style={{
                    position: "fixed",
                    top: "50%",
                    zIndex: 10,
                    right: 0,
                  }}
                >
                  <LogActivity log="Sales Order" id={id}></LogActivity>
                </div>
              )}
              <Col md={9}>
                <Form
                  className="needs-validation"
                  noValidate=""
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Card>
                    <CardBody>
                      <div className="form-row ">
                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">Customer</Label>

                            <AsyncSelect
                              className={` ${
                                errors.customer ? "is-invalid" : ""
                              }`}
                              isClearable
                              cacheOptions
                              defaultOptions
                              defaultValue={getValues("customer")}
                              loadOptions={typePromiseOption}
                              isDisabled={isReadOnly}
                              onChange={(e) => {
                                setValue("customer", e);
                                setValue("is_vat", e.is_vat);
                                trigger("customer");

                                setIsTax(e.id + "-" + e.is_vat);
                              }}
                            />
                            <div className="invalid-feedback">
                              {errors.customer?.message}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">
                              Customer PO
                            </Label>
                            <input
                              name="notes"
                              type="text"
                              {...register("customer_po_no")}
                              className={`form-control`}
                              readOnly={isReadOnly}
                            />
                            <div className="invalid-feedbac">
                              {errors.shippingAddress?.company?.message}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">Currency</Label>
                            <AsyncSelect
                              className={` ${
                                errors.customer ? "is-invalid" : ""
                              }`}
                              isClearable
                              cacheOptions
                              defaultOptions
                              defaultValue={getValues("currency")}
                              loadOptions={currencyTypePromiseOption}
                              isDisabled={isReadOnly}
                              onChange={(e) => {
                                setValue("currency", e);
                                handleCurrencyChange(e);
                              }}
                            />
                            <div className="invalid-feedback">
                              {errors.currency?.message}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label className="col-form-label">
                              Payment Method
                            </Label>
                            <AsyncSelect
                              className={` ${
                                errors.customer ? "is-invalid" : ""
                              }`}
                              isClearable
                              cacheOptions
                              defaultOptions
                              defaultValue={getValues("payment_method")}
                              loadOptions={paymentTypePromiseOption}
                              isDisabled={isReadOnly}
                              onChange={(e) => {
                                setValue("payment_method", e);
                                trigger("payment_method");
                              }}
                            />
                            <div className="invalid-feedback">
                              {errors.currency?.message}
                            </div>
                          </FormGroup>
                        </Col>
                      </div>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      {!isReadOnly && (
                        <Row>
                          <Col md="10 input-with-icon pr-1">
                            <div>
                              <FormGroup className="m-0">
                                <i className="fa fa-search"></i>
                                <input
                                  name="searchProduct"
                                  type="text"
                                  placeholder="Search Products"
                                  ref={(ref) => {
                                    searchProductRef.current = ref;
                                  }}
                                  onKeyUp={openSearchProductDialog}
                                  className={`form-control`}
                                />
                              </FormGroup>
                            </div>
                          </Col>
                          <Col md="2 pl-0">
                            <Button
                              color="primary"
                              type="button"
                              className="btn btn-sm btn-primary btn-block"
                              onClick={openSearchProductDialog}
                              style={{ height: 38 }}
                            >
                              Browse
                            </Button>
                          </Col>
                        </Row>
                      )}

                      <Row>
                        <Col md={12}>
                          {getValues("ordered_products").length > 0 && (
                              <SaleOrderProductJqx
                                  setValue={setValue}
                                  getValues={getValues}
                                  trigger={trigger}
                                  id={id}
                              onChangeDialog={onChangeDialog}
                              isTax={isTax}
                              isProductValueChange={isProductValueChange}
                              currencyChange={currencyChange}
                              isReadOnly={isReadOnly}
                            />
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              color: "red",
                              float: "right",
                            }}
                          >
                            {errors.ordered_products?.message}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  
                  {getValues("ordered_products").length > 0 && (
                    <Row>
                      <Col sm="12">
                        <SaleOrderPayment
                          setValue={setValue}
                          getValues={getValues}
                          trigger={trigger}
                          currency={getValues("currency").symbol}
                        ></SaleOrderPayment>
                      </Col>
                    </Row>
                  )}
                  
                  {/* Alert layout for all errors */}
                  {customErrorMessage.length > 0 && (
                    <div className="row">
                      <div className="col-12">
                        <div className="mb-3">
                          <div className="alert alert-danger" role="alert">
                            <ul style={{ marginBottom: 0 }}>
                              {customErrorMessage.map((msg, idx) => (
                                <li key={idx}>{msg}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {isReadOnly && (
                    <div className="alert alert-warning" role="alert">
                      This order cannot be edited. Only <strong>Confirmed</strong> status orders are editable.
                    </div>
                  )}

                  {getValues("ordered_products").length > 0 && !isReadOnly && (
                    <Card>
                      <CardBody>
                        <div
                          className="float-right"
                          style={{ display: "flex", alignItems: "center", gap: 8 }}
                        >
                          {isDateBlocked && (
                            <span className="text-danger">
                              Orders prior to 01-Mar-2026 cannot be edited.
                            </span>
                          )}
                          <ButtonLoader
                            disabled={buttonDisable || isDateBlocked}
                            color="primary"
                            value="1"
                            type="submit"
                            btntext="Save"
                          ></ButtonLoader>
                        </div>
                      </CardBody>
                    </Card>
                  )}
                </Form>
              </Col>
              <Col md={3}>
                {getValues("customer") && (
                  <OrderCustomerAddress
                    id={id}
                    getValues={getValues}
                    setValue={setValue}
                    salesOrderState={salesOrderState}
                    draftOrderState={draftOrderState}
                    customer={getValues("customer")}
                    addressError={{
                      shipping: errors.shippingAddress,
                      billing: errors.billingAddress,
                    }}
                  />
                )}
                {getValues("ordered_products").length > 0 && (
                  <Card>
                    <CardBody>
                      <h6 className="mb-3">Commodity Information</h6>
                      {/* eslint-disable-next-line no-undef */}
                      {orderCommodities(
                        getValues("ordered_products"),
                        getValues("currency").symbol
                      ).map((item, i) => (
                        <p key={i}>
                          {item.commodity} {item.quantity} Cost {item.amount}
                        </p>
                      ))}
                    </CardBody>
                  </Card>
                )}
                <Card>
                  <CardBody>
                    <h6 className="mb-3">Memo</h6>
                    <textarea
                      {...register("memo")}
                      className="form-control"
                      rows={3}
                      readOnly={isReadOnly}
                    ></textarea>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Container>
      <SearchProductModal
        orderSetValue={setValue}
        orderGetValues={getValues}
        orderTrigger={trigger}
        onChangeDialog={onChangeDialog}
        isProductValueChange={isProductValueChange}
        isAllowOutOfStock
        onAddProduct={handleAddProduct}
      ></SearchProductModal>
      <OrderDiscount
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></OrderDiscount>
      <OrderShipment
        draftOrderState={draftOrderState}
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></OrderShipment>
      <OrderTax
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></OrderTax>
      <SalesOrderDuty
        orderSetValue={setValue}
        orderTrigger={trigger}
        orderGetValues={getValues}
      ></SalesOrderDuty>
    </Fragment>
  );
};

export default withReducer([{ salesOrder: salesOrderReducer }])(SalesOrderForm);
